import { gql } from '@apollo/client'

export const GET_EMPTY_FACINGS_COUNT = gql`
  query GetEmptyFacingsCount($filters: DashboardFilter!) {
    emptyFacingsCount(filters: $filters) {
      label
      value
      previousValue
    }
  }
`
